// extracted by extract-css-chunks-webpack-plugin
module.exports = {"password-label":"password-label___UsSLq","label":"label___VbloB","eye":"eye___K1IKY","icon":"icon___SZOy5"};